module.exports = __webpack_public_path__ + "img/twitter_black.a9ffbdb1.png";